// GlobalHeader.vue
<template>
  <header class="header--global" :class="{ fixed: scrolling }">
    <div class="section__container">
      <div class="header__content">
        <a href="/" class="logo-link">
          <keep-alive>
            <img
              class="header__logo"
              :src="require('@/assets/img/Digu_Logo_Primary.webp')"
            />
          </keep-alive>
        </a>
        <desktop-menu @menu-state-change="handleMenuStateChange" />
        <mobile-menu />
      </div>
    </div>
  </header>
  <!-- Content blur overlay -->
  <div v-if="isMenuOpen" class="content-blur-overlay"></div>
</template>

<script>
import DesktopMenuVue from '@/components/partials/DesktopMenu.vue';
import MobileMenuVue from '@/components/partials/MobileMenu.vue';

export default {
  name: 'GlobalHeader',
  components: {
    'desktop-menu': DesktopMenuVue,
    'mobile-menu': MobileMenuVue,
  },
  data: () => ({
    screen: `${window.screen.width}x${window.screen.height}`,
    shouldShowScreenSize: process.env.NODE_ENV == 'development',
    scrolling: false,
    isMenuOpen: false,
  }),
  methods: {
    floatHeader() {
      if (window.scrollY != 0) {
        this.scrolling = true;
      }
      if (window.scrollY == 0) {
        this.scrolling = false;
      }
    },
    handleMenuStateChange(isOpen) {
      this.isMenuOpen = isOpen;
    }
  },
  mounted() {
    document.addEventListener('scroll', this.floatHeader);
  },
  unmounted() {
    document.removeEventListener('scroll', this.floatHeader);
  },
};
</script>

<style scoped>
.header--global {
  padding-block: 1rem;
  background-color: var(--light-1);
  transition: all 100ms ease-in-out;
  position: relative;
  z-index: 1001;
}

.section__container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 0rem;
}

.header__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.logo-link {
  flex-shrink: 0;
}

.fixed {
  padding-inline: 1rem !important;
  z-index: 1001;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0px 8px 16px #00000011;
}

.content-blur-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  z-index: 1000;
  pointer-events: none;
}

.header__logo {
  height: 2.25rem;
  transition: height 50ms ease-in-out;
}

@media only screen and (min-width: 1280px) {
  .header__logo {
    height: 2rem;
  }

  .fixed .header__logo {
    height: 2rem;
  }
}

@media only screen and (min-width: 2000px) {
  .section__container {
    max-width: 1920px;
  }
}
</style>